import React, { FC } from 'react';

export interface HorizontalLineProps extends React.SVGProps<SVGPathElement> {
  y: number;
  text?: string;
}

const FONT_SIZE = 12;

const HorizontalLine: FC<HorizontalLineProps> = props => {
  return (
    <g>
      {props.text && (
        <text
          x="12"
          fillOpacity="1"
          y={props.y - FONT_SIZE / 2}
          fontSize={FONT_SIZE}
          fontWeight="500"
          fill={props.color}
        >
          {props.text}
        </text>
      )}
      <path
        {...props}
        fillOpacity="1"
        d={`M 0 ${props.y} L ${props.width} ${props.y}`}
        stroke={props.color}
        fill="none"
        strokeWidth={props.strokeWidth ? props.strokeWidth : 1}
      ></path>
    </g>
  );
};

export { HorizontalLine };
